// extracted by mini-css-extract-plugin
export var box = "_79-1";
export var checked = "_79-2";
export var descriptionSpacer = "_79-9";
export var disabled = "_79-3";
export var icon = "_79-6";
export var input = "_79-0";
export var labelSpacer = "_79-8";
export var medium = "_79-5";
export var small = "_79-4";
export var text = "_79-7";